<template>
	<div class="md-layout">
		<entity-card v-bind="{ schema, readEntity, deleteEntity, createEntity, updateEntity, swipeText, swipeFunction }" :entity.sync="entity"></entity-card>
	</div>
</template>

<script>
	import User from "@/models/user.model.vue"
	import EntityCard from "@/components/Espresso/EntityCard.vue"
	import EspressoAux from "@/components/Espresso/EspressoAux.vue"

	export default {
		components: {
			EntityCard,
		},
		data() {
			return {
				entity: {
					id: this.$route.params.id,
				},

				schema: User.getSchema(),
				swipeText: null,
			}
		},
		methods: {
			async readEntity(entityId) {
				return User.getInfo(entityId);
			},
			async deleteEntity(entityId) {
				await User.remove(entityId);
				if (this.entity.role === "ADMIN") {
					this.$router.push(`/administradores`);
				} else if (this.entity.role === "USER") {
					this.$router.push(`/usuarios`);
				}
			},
			async updateEntity(entity) {
				const dataToUpdate = Object.assign({}, entity);
				delete dataToUpdate.role;
				return User.updateInfo(dataToUpdate);
			},
			async createEntity(entity) {
				this.entity = await User.create(entity);
				this.$router.replace(`/usuario/${this.entity.id}`);
				return this.entity;
			},
			async swipeFunction(value) {
				return User.swipeStatus(this.entity.id, value);
			},
		},
		mounted() {
			if (this.entity.id && this.entity.id !== "novo") {
				EspressoAux.executeAsync(async () => {
					this.localEntity = await this.readEntity(this.entity.id);
					if (this.localEntity.role === "USER") this.swipeText = "Ativar/Suspender Usuário";
				}, null, "Erro ao carregar informações!");
			}
		},
	};
</script>
